import React from "react";
import { motion } from "framer-motion";

export const SourceDataRenderer = ({
  sourceData,
  sourceDataRenderer,
  currentNode,
}) => {
  const renderField = (title, config, index) => {
    return (
      <motion.div
        key={title}
        className="mb-2"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, delay: index * 0.1 }}
      >
        <h3 className="text-xs font-medium text-gray-700">{title}</h3>
        <p className="mt-1 text-sm text-gray-900">{config.value}</p>
      </motion.div>
    );
  };

  return (
    <div className="overflow-scroll px-6">
      <div className="flex items-center justify-between pt-8 mb-1">
        <h1 className="text-lg font-semibold text-gray-900">
          Review source data
        </h1>
      </div>
      <p className="text-xs text-slate-600 mb-4">
        This is the data we used to build your automation.
      </p>

      <div className="sm:p-0">
        <dl className="sm:divide-y sm:divide-gray-200">
          <motion.div
            className="py-4 sm:py-5 sm:grid sm:grid-cols-1 sm:gap-4"
            initial="hidden"
            animate="visible"
            variants={{
              visible: {
                transition: {
                  staggerChildren: 0.1,
                },
              },
            }}
          >
            {sourceDataRenderer &&
              Object.entries(sourceDataRenderer)
                .sort((a, b) => a[1].index - b[1].index)
                .map(([title, config], index) => renderField(title, config, index))}
          </motion.div>
        </dl>
      </div>
      {currentNode?.sourceDataLink && (
        <a
          href={currentNode.sourceDataLink.link}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block"
        >
          <div className="bg-white border shadow-sm cursor-pointer -ml-2 rounded-full text-xs font-medium text-slate-700 px-4 py-2 hover:outline-2 hover:outline-slate-100 transition-colors">
            {currentNode.sourceDataLink.displayTitle || "View at source"}
          </div>
        </a>
      )}
    </div>
  );
};
